const lockBackgroundScroll = () => {
  document.body.style.overflow = 'hidden';
};

const unlockBackgroundScroll = () => {
  document.body.style.overflow = 'unset';
};

export { lockBackgroundScroll, unlockBackgroundScroll };
